module.exports = __webpack_public_path__ + "img/000.85fae059.jpg";